// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  LOGIN_DISABLED: false,
  DEVICES_API_ENDPOINT: "https://cl63vnzdx2.execute-api.us-east-1.amazonaws.com/test/",
  googleAPIKey: "AIzaSyCKqF5wJDTJAWxfTp_w5RPJi_d3dMpxgCw",
  USE_API_KEY: false,
  ENABLE_AUTO_REFRESH: true,
  USE_COOKIES: false,
  MAX_BULK_DEVICE_OPERATIONS: 25
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
